/* eslint-disable import/prefer-default-export */
export function mapWidgets(fields) {
  return Object.assign({}, ...fields.map(
    (item) => ({
      [item.key]: {
        get() {
          return this.$store.getters[`widget${this.id}/getItem`][item.path][item.key];
        },
        set(value) {
          const payload = {
            data: [
              {
                path: item.path,
                key: item.key,
                value,
              },
            ],
          };

          this.$store.dispatch(`widget${this.id}/UPDATE_WIDGET`, payload);
        },
      },
    }),
  ));
}
